// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { calendarDay16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-calendar-day': IconCalendarDay;
    }
}

/**
 * The icon component for the 'calendarDay' icon
 */
export class IconCalendarDay extends Icon {
    public constructor() {
        super(calendarDay16X16);
    }
}

registerIcon('icon-calendar-day', IconCalendarDay);
export const iconCalendarDayTag = 'nimble-icon-calendar-day';
